import { render } from "./RtxBookingB2C.vue?vue&type=template&id=202a9a98&scoped=true"
import script from "./RtxBookingB2C.vue?vue&type=script&lang=js"
export * from "./RtxBookingB2C.vue?vue&type=script&lang=js"

import "./RtxBookingB2C.vue?vue&type=style&index=0&id=202a9a98&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-202a9a98"]])

export default __exports__